<template class="flex-grow-1" >
    <div style="height: 100%" @keydown.esc="hideBuildingInfo">
        <b-card style="position:absolute;top: 66px;right:10px; z-index: 1000; width:20vw">
            <b-card-body>
                <b-row v-if="loading">
                    <b-col>
                        Загрузка...
                    </b-col>
                    <hr>
                </b-row>
                <b-row>
                    <b-col>
                        <input
                                id="schoolsCheckbox"
                                v-model="showSchools"
                                type="checkbox"
                        >
                    </b-col>
                    <b-col cols="10">
                        <label for="schoolsCheckbox">Показывать школы</label>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <input
                                id="buildingsCheckbox"
                                v-model="showBuildings"
                                type="checkbox"
                        >
                    </b-col>
                    <b-col cols="10">
                        <label for="buildingsCheckbox">Показывать жилые дома</label>
                    </b-col>

                </b-row>
                <MapLegend></MapLegend>
            </b-card-body>
        </b-card>
        <b-card style="position:absolute;top: 66px;left:10px; z-index: 1000; width:20vw" v-if="showBuildingInfo" header-tag="header">
            <template v-slot:header >
                <div class="d-flex flex-row-reverse">
                    <a href="#" @click="hideBuildingInfo">X</a>
                </div>
            </template>
            <b-row>
                <b-col>
                    <b>
                        {{this.selectedBuilding.properties.address}}
                    </b>
                </b-col>
            </b-row>
            <hr>
            <b-row>
                <b-col>
                    <b-table-simple :borderless="true">
                        <b-tr>
                            <b-td>Жителей</b-td>
                            <b-td>{{this.selectedBuilding.properties.totalPopulation}}</b-td>
                        </b-tr>
                        <b-tr>
                            <b-td>Школьников</b-td>
                            <b-td>{{this.selectedBuilding.properties.schoolAgePopulation}}</b-td>
                        </b-tr>
                    </b-table-simple>

                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <span v-html="getCategoryColoredText(this.selectedBuilding.properties.category)"></span>
                </b-col>
            </b-row>
        </b-card>
        <l-map ref="map"
               :zoom="zoom"
               :center="center"
               class="flex-grow-1"
               v-on:update:center="mapUpdate"
               v-on:update:zoom="zoomChanged"
               v-on:ready="mapUpdate"
               @click="hideBuildingInfo"
        >
            <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
            <l-geo-json
                    v-if="showSchools && !showBuildingInfo"
                    :geojson="schoolsGeoJson"
                    :options="schoolsOptions"
            />
            <l-geo-json
                    v-if="showBuildings && !showBuildingInfo"
                    :geojson="buildingsGeoJson"
                    :options="buildingsOptions"
            />
            <l-geo-json
                    v-if="showBuildingInfo"
                    :geojson="currentBuildingGeoJson"
                    :options="buildingsOptions"
            />
        </l-map>
    </div>
</template>

<script>
    import {latLng} from "leaflet";
    import {LGeoJson, LMap, LTileLayer} from 'vue2-leaflet';
    import MapLegend from './MapLegend';

    export default {
        name: "SchoolMap.vue",
        components: {
            LMap,
            LTileLayer,
            LGeoJson,
            MapLegend
        },
        data() {
            return {
                loading: false,
                zoom: 15,
                center: latLng(59.939468, 30.308769),
                url: ' https://{s}.basemaps.cartocdn.com/rastertiles/light_all/{z}/{x}/{y}.png',
                attribution:
                    '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
                schoolsGeoJson: null,
                buildingsGeoJson: null,
                fillColor: "#e4ce7f",
                bbox: null,
                showSchools: true,
                showBuildings: true,
                prevZoom: 0,
                prevCenter: null,
                showBuildingInfo: false,
                currentBuildingGeoJson: null,
                selectedBuilding: null
            };
        },
        methods: {

            getCategoryColoredText(category) {
                switch (category) {
                    case 'NO_SCHOOLS':
                        return "<p style='color: red'>Нет школ поблизости</p>"
                    case  'NOT_ENOUGH_PLACES_IN_AREA':
                        return "<p style='color: orange'> Нет мест в шаговой доступности</p>"
                    case 'ENOUGH_IN_AREA':
                        return "<p style='color: rgba(174,127,0,0.97)'>Есть места в пешеходной доступности</p>"
                    case 'ENOUGH_IN_NEAREST':
                        return "<p style='color:#1E9E0B'>Есть места в ближайшей школе</p>"
                    case 'NO_ENOUGH_PLACES_IN_NEAREST':
                        return "<p style='color:#49D16D'>Есть места в ближайшей школе, проектная вместимость превышена</p>"
                    case 'NO_CHILDREN':
                        return "<p style='color:gray'>Нет жителей школьного возраста</p>"
                }
                return ''
            },

            onEachBuilding(feature, layer) {
                layer.on({
                    click: this.onBuildingClicked
                });
                layer.setStyle(this.buildingsStyleFunction(feature))
                let tooltip = "<div>" + feature.properties.address +
                    "</div><div>Всего жителей: " +
                    feature.properties.totalPopulation +
                    "</div><div>Жителей школьного возраста: " +
                    feature.properties.schoolAgePopulation +
                    "</div><div>";

                tooltip += this.getCategoryColoredText(feature.properties.category)
                tooltip += "</div>";
                layer.bindTooltip(
                    tooltip,
                    { permanent: false, sticky: true }
                );
            },

            hideBuildingInfo() {
                this.showBuildingInfo = false;
            },

            onEachSchool(feature, layer) {
                layer.setStyle(this.schoolStyleFunction(feature))
                let capacity = feature.properties.capacity;
                let students = feature.properties.students;
                let fill = (students / capacity * 100).toFixed(0)
                let content = "<div>" +
                    "<p class='text-wrap'><b>" + feature.properties.name + "</b></p></div>" +
                    "<div>" + feature.properties.address +
                    "</div><div>Количество мест: " +
                    capacity +
                    "</div><div>Количество учеников: " +
                    students + "</div><div>";
                if (students < capacity) {
                    content += "<p style='color:#241ABB'>Есть свободные места, заполненность " + fill + "%</p>"
                } else if (students < 1.5 * capacity) {
                    content += "<p style='color:#3FA3F1'>Нет мест, заполненность " + fill + "%</p>"
                } else {
                    content += "<p style='color:#0CF4DA'>Нет мест, заполенность " + fill + "%</p>"
                }
                content += "</div>"


                layer.bindTooltip(
                    content,
                    { permanent: false, sticky: true }
                );
            },

            onEachRoute(feature, layer) {
                layer.setStyle(this.routeStylingFunction(feature))
                let content = "<div>"
                if (feature.properties.nearest) {
                    content += "Маршрут до ближайшей школы"
                } else {
                    content += "Маршрут до школы в пешеходной доступности"
                }
                content += "</div>";
                content += `<div>${feature.properties.distance.toFixed(0)} метров</div>`
                content += `<div>${feature.properties.students.toFixed(0)} учеников</div>`
                content += `<div>${feature.properties.minutes} минут</div>`
                layer.bindTooltip(
                    content,
                    { permanent: false, sticky: true }
                )
            },

            mapUpdate() {
                let mapObject = this.$refs.map.mapObject;
                if (this.prevCenter === mapObject.getCenter()) {
                    // just a zoom, shall be already handled by zoomChanged()
                    return;
                }
                this.bbox = mapObject.getBounds();
                this.fetchData();
                this.prevZoom =  mapObject.getZoom();
                this.prevCenter = mapObject.getCenter()
            },

            zoomChanged() {
                // only fetch new data if we are zooming out and are seeing more buildings
                let mapObject = this.$refs.map.mapObject;
                let newZoom = mapObject.getZoom();
                console.log(`Old zoom ${this.prevZoom}, new zoom ${newZoom}, shall update: ${newZoom < this.prevZoom}`)
                if (newZoom < this.prevZoom) {
                    this.fetchData();
                }
                this.prevZoom =  mapObject.getZoom();
                this.prevCenter = mapObject.getCenter()
            },

            async fetchSchools() {
                let url = process.env.VUE_APP_API_URL + "/map/schools?" + this.boundingBoxParams;
                const response = await fetch(url);
                this.schoolsGeoJson = await response.json();

            },

            async fetchBuildings() {
                let url = process.env.VUE_APP_API_URL +  "/map/buildings?" + this.boundingBoxParams;
                const response = await fetch(url);
                this.buildingsGeoJson = await response.json();

            },

            async fetchData() {
                this.loading = true;
                await Promise.all([this.fetchSchools(), this.fetchBuildings()]);
                this.loading = false;
            },

            async onBuildingClicked(event) {
                let feature = event.target.feature
                let url = process.env.VUE_APP_API_URL + "/map/building/" + feature.properties.id;
                const response = await fetch(url);
                this.currentBuildingGeoJson = await response.json();
                this.showBuildingInfo = true
                this.selectedBuilding = feature
            },

            routeStylingFunction(feature) {
                let color = "red"
                if (feature.properties.nearest) {
                    color = "blue"
                }
                return {
                    weight: 3,
                    opacity: 1,
                    color: color,
                    dashArray: "30 10",
                };
            },

            buildingsStyleFunction(feature) {
                let fillColor = "gray"
                if (feature.properties.category !== undefined) {
                    switch (feature.properties.category) {
                        case 'NO_SCHOOLS':
                            fillColor = "red";
                            break;
                        case  'NOT_ENOUGH_PLACES_IN_AREA':
                            fillColor = 'orange';
                            break;
                        case 'NO_ENOUGH_PLACES_IN_NEAREST':
                            fillColor = '#49D16D';
                            break;
                        case 'ENOUGH_IN_AREA':
                            fillColor = "#dff61a";
                            break;
                        case 'ENOUGH_IN_NEAREST':
                            fillColor = '#1E9E0B'
                            break;
                    }
                }
                return {
                    weight: 2,
                    opacity: 1,
                    fillColor: fillColor,
                    color: fillColor,
                    fillOpacity: 1
                };
            },

            schoolStyleFunction(feature) {
                let fillColor = "blue"
                let capacity = feature.properties["capacity"];
                let students = feature.properties["students"];
                if (students > 1.5 * capacity) {
                    fillColor = "#0CF4DA"
                } else if (students >= capacity) {
                    fillColor = "#3FA3F1"
                } else {
                    fillColor = "#241ABB"
                }

                return {
                    weight: 2,
                    opacity: 1,
                    fillColor: fillColor,
                    color: fillColor,
                    fillOpacity: 1
                };

            },

        },
        computed: {
            boundingBoxParams() {
                if (this.bbox === null) {
                    return ""
                }
                const bbox = this.bbox;
                return `east=${bbox.getEast()}&west=${bbox.getWest()}&south=${bbox.getSouth()}&north=${bbox.getNorth()}&zoom=${this.zoom}`
            },

            buildingsOptions() {
                return {
                    onEachFeature: this.onEachFeature
                };
            },

            schoolsOptions() {
                return {
                    onEachFeature: this.onEachFeature
                };
            },

            onEachFeature() {
                return (feature, layer) => {
                    switch (feature.properties.type) {
                        case "building":
                            this.onEachBuilding(feature, layer);
                            break;
                        case "school":
                            this.onEachSchool(feature, layer);
                            break;
                        case "route":
                            this.onEachRoute(feature, layer)

                    }
                }
            },



        },

    }
</script>

<style scoped>

</style>